function setImage({ imageString }: { imageString: string }) {
    try {
        // Validate we have a string to process
        if (!imageString || typeof imageString !== 'string') {
            console.error("Invalid image data received:", typeof imageString);
            return '';
        }

        const binaryData = atob(imageString);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        // Check magic bytes for content type (more reliable than guessing)
        // This examines the first few bytes to determine file type
        let contentType = 'image/png';
        if (uint8Array[0] === 0xFF && uint8Array[1] === 0xD8) {
            contentType = 'image/jpeg';
        } else if (uint8Array[0] === 0x47 && uint8Array[1] === 0x49 && uint8Array[2] === 0x46) {
            contentType = 'image/gif';
        }

        const blob = new Blob([uint8Array], { type: contentType });
        const file = new File([blob], 'img', { type: contentType });
        const dataURL = URL.createObjectURL(file);
        return dataURL;
    } catch (error) {
        console.error("Error processing image:", error);
        return '';
    }
}

export default setImage;